export default {
  key: 'sidebar-opened',
  get() {
    const result = JSON.parse(localStorage.getItem(this.key));
    if (result === null) {
      return true;
    }

    return result;
  },
  set(value) {
    localStorage.setItem(this.key, JSON.stringify(value));
  },
};
